<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('loan1')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox" v-loading="loading">
                <el-tabs type="border-card" style="width: 100%;">
                    <el-tab-pane :label="$t('tel43')">
                        <el-tabs type="border-card" style="width: 100%;">
                            <el-tab-pane :label="$t('call3')">
                                <div class="listright">
                                    <el-table :data="list" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="case" :label="$t('loan3')" width="90"></el-table-column>
                                        <el-table-column prop="callNum" :label="$t('loan7')"></el-table-column>
                                        <el-table-column prop="payment" :label="$t('oter')"></el-table-column>
                                        <el-table-column prop="defer" :label="$t('loan8')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('loan4')">
                                <div class="listright">
                                    <el-table :data="list1" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <!-- <el-table-column prop="lendingDate" :label="$t('loan2')" width="100"></el-table-column> -->
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="case" :label="$t('loan3')" width="100"></el-table-column>
                                        <el-table-column prop="callNum" :label="$t('loan7')"></el-table-column>
                                        <el-table-column prop="payment" :label="$t('oter')"></el-table-column>
                                        <el-table-column prop="defer" :label="$t('loan8')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('loan5')">
                                <div class="listright">
                                    <el-table :data="list2" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="case" :label="$t('loan3')" width="100"></el-table-column>
                                        <el-table-column prop="callNum" :label="$t('loan7')"></el-table-column>
                                        <el-table-column prop="payment" :label="$t('oter')"></el-table-column>
                                        <el-table-column prop="defer" :label="$t('loan8')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('tel44')">
                        <el-tabs type="border-card" style="width: 100%;">
                            <el-tab-pane :label="$t('call3')">
                                <div class="listright">
                                    <el-table :data="list3" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="amountDue" :label="$t('c17')"></el-table-column>
                                        <el-table-column prop="amountCall" :label="$t('c18')"></el-table-column>
                                        <el-table-column prop="amountPayment" :label="$t('c19')"></el-table-column>
                                        <el-table-column prop="amountDefer" :label="$t('c20')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('loan4')">
                                <div class="listright">
                                    <el-table :data="list4" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="amountDue" :label="$t('c17')"></el-table-column>
                                        <el-table-column prop="amountCall" :label="$t('c18')"></el-table-column>
                                        <el-table-column prop="amountPayment" :label="$t('c19')"></el-table-column>
                                        <el-table-column prop="amountDefer" :label="$t('c20')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('loan5')">
                                <div class="listright">
                                    <el-table :data="list5" height="800"
                                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                        <el-table-column prop="dueDate" :label="$t('expireTime')" width="100"></el-table-column>
                                        <el-table-column prop="amountDue" :label="$t('c17')"></el-table-column>
                                        <el-table-column prop="amountCall" :label="$t('c18')"></el-table-column>
                                        <el-table-column prop="amountPayment" :label="$t('c19')"></el-table-column>
                                        <el-table-column prop="amountDefer" :label="$t('c20')"></el-table-column>
                                        <el-table-column prop="T2" label="T-2"></el-table-column>
                                        <el-table-column prop="T1" label="T-1"></el-table-column>
                                        <el-table-column prop="D0" label="D0"></el-table-column>
                                        <el-table-column prop="D1" label="D1"></el-table-column>
                                        <el-table-column prop="D2" label="D2"></el-table-column>
                                        <el-table-column prop="D3" label="D3"></el-table-column>
                                        <el-table-column prop="D4" label="D4"></el-table-column>
                                        <el-table-column prop="D5" label="D5"></el-table-column>
                                        <el-table-column prop="D6" label="D6"></el-table-column>
                                        <el-table-column prop="D7" label="D7"></el-table-column>
                                        <el-table-column prop="D8" label="D8"></el-table-column>
                                        <el-table-column prop="D9" label="D9"></el-table-column>
                                        <el-table-column prop="D10" label="D10"></el-table-column>
                                        <el-table-column prop="D11" label="D11"></el-table-column>
                                        <el-table-column prop="D12" label="D12"></el-table-column>
                                        <el-table-column prop="D13" label="D13"></el-table-column>
                                        <el-table-column prop="D14" label="D14"></el-table-column>
                                        <el-table-column prop="D15" label="D15"></el-table-column>
                                        <el-table-column prop="D16" label="D16"></el-table-column>
                                        <el-table-column prop="D17" label="D17"></el-table-column>
                                        <el-table-column prop="D18" label="D18"></el-table-column>
                                        <el-table-column prop="D19" label="D19"></el-table-column>
                                        <el-table-column prop="D20" label="D20"></el-table-column>
                                        <el-table-column prop="D21" label="D21"></el-table-column>
                                        <el-table-column prop="D22" label="D22"></el-table-column>
                                        <el-table-column prop="D23" label="D23"></el-table-column>
                                        <el-table-column prop="D24" label="D24"></el-table-column>
                                        <el-table-column prop="D25" label="D25"></el-table-column>
                                        <el-table-column prop="D26" label="D26"></el-table-column>
                                        <el-table-column prop="D27" label="D27"></el-table-column>
                                        <el-table-column prop="D28" label="D28"></el-table-column>
                                        <el-table-column prop="D29" label="D29"></el-table-column>
                                        <el-table-column prop="D30" label="D30"></el-table-column>
                                        <el-table-column prop="D31" label="D31"></el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                loading: false,
                list: [],
                list1: [],
                list2: [],
                list3: [],
                list4: [],
                list5: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.loan, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.list1 = res.data.list1
                    this.list2 = res.data.list2
                    this.list3 = res.data.list3
                    this.list4 = res.data.list4
                    this.list5 = res.data.list5
                })
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>